// extracted by mini-css-extract-plugin
module.exports = {"spacer":"bb_dr"};